import styled from 'styled-components';

export default styled.div`
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0 2px 4px 0 rgba(60, 63, 68, 0.15);
    background-color: #fff;
`;
